<template>
  <div v-if="isLoading" class="spinner-container">
    <b-spinner type="grow" label="Loading..." :variant="variant" />
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'

export default {
    name: 'GlobalSpinner',
    components: {
        BSpinner,
    },
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
        variant: {
            type: String,
            default: '',
        },
    },
}
</script>

<style scoped>
/* The style is controlled from the parent */
</style>
